
import Advert from '../Advert';
import Content, * as ContentConstants from '../Content';
import { colorConversionToCss } from '../CMS';

import Media from './Media';

import { IE11_safeFrameElement } from '../../helpers/utils';

import ExternalConfiguration from '../../external-configuration';

// export const processDownload = download => {
//   return (download && true) || false;
// };

// export const processSkin = ( design = {} ) => {
//   // console.log( 'controllers::custom_3_player::Configuration::processSkin() - design: ', design);    // DEVELOP
//   const skin = { ...ExternalConfiguration.Custom3PlayerDefaults.skin };

//   // NOTE bloque fallback para version antigua
//   if( design?.colorBar) {
//     const background = colorConversionToCss( design.colorBar);
//     skin.controlbar.background = background;
//     skin.menus.background = background;
//     skin.tooltips.background = background;
//   }// NOTE fin fallback

//   if( design?.skin?.controlbar?.text) skin.controlbar.text = design.skin.controlbar.text;
//   if( design?.skin?.controlbar?.icons) skin.controlbar.icons = design.skin.controlbar.icons;
//   if( design?.skin?.controlbar?.iconsActive) skin.controlbar.iconsActive = design.skin.controlbar.iconsActive;
//   if( design?.skin?.controlbar?.background) skin.controlbar.background = design.skin.controlbar.background;
//   if( design?.skin?.timeslider?.progress) skin.timeslider.progress = design.skin.timeslider.progress;
//   if( design?.skin?.timeslider?.rail) skin.timeslider.rail = design.skin.timeslider.rail;
//   if( design?.skin?.menus?.text) skin.menus.text = design.skin.menus.text;
//   if( design?.skin?.menus?.textActive) skin.menus.textActive = design.skin.menus.textActive;
//   if( design?.skin?.menus?.background) skin.menus.background = design.skin.menus.background;
//   if( design?.skin?.tooltips?.text) skin.tooltips.text = design.skin.tooltips.text;
//   if( design?.skin?.tooltips?.background) skin.tooltips.background = design.skin.tooltips.background;

//   return skin;
// };

// export const processSharing = ( networks = {} ) => {   // REVIEW interest/pinterest documentation bug ?? https://docs.jwplayer.com/players/reference/sharing-config-ref
//   const ReplaceNeworkTable = { mail: 'email'};    // NOTE accepted values: facebook, twitter, pinterest, email, tumblr, linkedin, reddit
//   if( networks && networks.length > 0) {
//     const frameElement = IE11_safeFrameElement();
//     const code = frameElement ? frameElement.outerHTML : '<iframe src="' + document.URL + '"></iframe>';
//     const sites = networks.map( network => (network in ReplaceNeworkTable ? ReplaceNeworkTable[network] : network));
//     return {
//       code: code,
//       link: /src=["']([^"']*)["']/.exec(code)[1],
//       sites: sites,
//     };
//   } else {
//     return null;
//   }
// };

// export const processLogo = ( design = {} ) => {
//   if( design.logoUrl && design.logoUrl !== '') {
//     const validPositions = [ 'top-left', 'top-right', 'bottom-left', 'bottom-right'];
//     const position = 'logoPosition' in design && validPositions.indexOf(design.logoPosition) > -1 ? design.logoPosition : 'top-left';
//     const logo = {
//       file: design.logoUrl,
//       position,
//     };
//     if( 'logoLink' in design && design.logoLink !== '') {
//       logo.link = design.logoLink;
//     };
//     return logo;
//   }
//   return undefined;
// };

// const processAdvertisement = ( adserver, advert) => {   // REVIEW
//   const startFromVideo = 0;   // TODO parametrizar
//   const playlist = [ null];   // TODO parametrizar

//   const adschedules = [];
//   const advertising = {
//     client: 'vast',
//   };

//   if( adserver) {
//     advertising.schedule = [{
//       offset: 'pre',
//       tag: adserver,
//     }];
//     return { advertising };
//   } else if( advert) {
//     adschedules[ startFromVideo] = `data:text/xml,${Advert.generateVMAP( advert)}`;    // REVIEW TODO playlist
//     return { advertising, adschedules };
//   } else return {};
// };

const processContent = loadedConfiguration => {
  const { singleMedia, playlist = [], mainWithBackups, balancedFallbacks, multiChannel, contentType, errorMedia } = Content.processConfiguration( loadedConfiguration, Media.processMedia);
  let firstContent, auxiliarData;
  // const updateAuxiliarDataFromProcessedMedia = media => {
  //   return {
  //     posterUrl: media.image,
  //     mediaSrcType: media.srcType,
  //     chaptersUrl: media.chapters,
  //     captions: media.captions,
  //   };
  // };

  // switch( contentType) {
  //   case ContentConstants.ContentTypes.SingleMedia:
  //     playlist.push( singleMedia);
  //     auxiliarData = updateAuxiliarDataFromProcessedMedia( singleMedia);
  //     break;
  //   case ContentConstants.ContentTypes.Playlist:
  //     auxiliarData = updateAuxiliarDataFromProcessedMedia( playlist[0]);    // REVIEW
  //     break;
  //   case ContentConstants.ContentTypes.MainWithBackups:
  //     firstContent = mainWithBackups.contents[ mainWithBackups.current];
  //     playlist.push( firstContent);
  //     auxiliarData = updateAuxiliarDataFromProcessedMedia( firstContent);
  //     break;
  //   case ContentConstants.ContentTypes.BalancedFallbacks:
  //     firstContent = balancedFallbacks.contents[ balancedFallbacks.current];
  //     playlist.push( firstContent);
  //     auxiliarData = updateAuxiliarDataFromProcessedMedia( firstContent);
  //     break;
  //   case ContentConstants.ContentTypes.MultiChannel:
  //     firstContent = multiChannel.contents[ multiChannel.current];
  //     playlist.push( firstContent);
  //     auxiliarData = updateAuxiliarDataFromProcessedMedia( firstContent);
  //     break;
  //   default:;
  // }

  // PATCH FALLBACK
  auxiliarData = { posterUrl: '', mediaSrcType: null, chapersUrl: [], captions: [] };

  const contentData = {
    contentType,
    mainWithBackups,
    balancedFallbacks,
    multiChannel,
    errorMedia,
  };
  return { playlist, contentData, auxiliarData };
};

const THEOplayer_player_Configuration = {

  processConfiguration: (loadedConfiguration = {}) => {
  
    const theoplayer_playerConfiguration = {
      // customProps: {
      //   skin: processSkin( loadedConfiguration.design),
      //   abouttext: ExternalConfiguration.Custom3PlayerDefaults.aboutText,
      //   aboutlink: ExternalConfiguration.Custom3PlayerDefaults.aboutLink,
      //   autostart: (loadedConfiguration.autoplay && true) || false,
      //   cast: loadedConfiguration.cast ? {} : undefined,
      // },
      // auxiliarData: {
      //   download: processDownload( loadedConfiguration.download),
      // },
      // key: Math.random(),
    };

    // if( loadedConfiguration.relatedMediaUrl) {
    //   theoplayer_playerConfiguration.customProps.related = {
    //     file: loadedConfiguration.relatedMediaUrl,
    //   };
    // }

    // const sharing = processSharing( loadedConfiguration.socialSharing);
    // if( sharing) theoplayer_playerConfiguration.customProps.sharing = sharing;
    // const logo = processLogo( loadedConfiguration.design);
    // if( logo) theoplayer_playerConfiguration.customProps.logo = logo;
    // const { advertising, adschedules } = processAdvertisement( loadedConfiguration.adserver, loadedConfiguration.advert);   // REVIEW

    const { playlist, contentData, auxiliarData } = processContent( loadedConfiguration);
    // theoplayer_playerConfiguration.playlist = playlist;
    // if( theoplayer_playerConfiguration?.customProps?.skin?.menus?.background && auxiliarData ) {
    //   auxiliarData.menusBackground = theoplayer_playerConfiguration.customProps.skin.menus.background;
    // }
    // if( playlist[0]?.file && auxiliarData ) {
    //   auxiliarData.firstUrl = playlist[0].file;   // TODO TOFIX REVIEW esto se usa solo para pasarle la url al CustomLogger evaluar especializarlo mas y que se actualice al cambiar el elemento reproduciendose
    // }

    // if( advertising) {    // REVIEW 
    //   theoplayer_playerConfiguration.customProps.advertising = advertising;
    //   if( adschedules) {
    //     theoplayer_playerConfiguration.playlist.forEach( (media,i) => {
    //       if( i in adschedules) media.adschedule = adschedules[i];
    //     });
    //   }
    // }

    return { theoplayer_playerConfiguration, contentData, auxiliarData };
  },

};

export default THEOplayer_player_Configuration;

